import axios from "axios"
import { memo } from "react"

// for deve
// const baseURL = "http://targettest.asktek.net/target.ankita.adminpanel.webapi/api/"

// test api
const baseURL =
  "http://targettest.asktek.net/target.ankita.adminpanel.webapi/api"

const instance = axios.create({
  baseURL,
})

export default {
  instance,
  baseURL,
}

// please note while run build if you face any heap memory issue then add below code run below code
// node --max-old-space-size=4096 ./node_modules/react-scripts/bin/react-scripts.js build
